import type { JSX } from "react";
import type { TimerAlertSettings } from "./useRecipeTimers";
import { saveTimerAlertSettings } from "./timer-alerts";

type TimerAlertSettingsPanelProps = {
  settings: TimerAlertSettings;
  onChange: (settings: TimerAlertSettings) => void;
};

export function TimerAlertSettingsPanel({ settings, onChange }: TimerAlertSettingsPanelProps): JSX.Element {
  return (
    <details className="timer-alert-settings">
      <summary>Timer alerts</summary>
      <div className="timer-alert-options">
        <label>
          <input
            type="checkbox"
            checked={settings.vibration}
            onChange={(event) => {
              const next = { ...settings, vibration: event.target.checked };
              saveTimerAlertSettings(next);
              onChange(next);
            }}
          />
          Vibration
        </label>
        <label>
          <input
            type="checkbox"
            checked={settings.sound}
            onChange={(event) => {
              const next = { ...settings, sound: event.target.checked };
              saveTimerAlertSettings(next);
              onChange(next);
            }}
          />
          Sound
        </label>
        <label>
          <input
            type="checkbox"
            checked={settings.headerFlash}
            onChange={(event) => {
              const next = { ...settings, headerFlash: event.target.checked };
              saveTimerAlertSettings(next);
              onChange(next);
            }}
          />
          Header flash
        </label>
      </div>
    </details>
  );
}
